<template>
  <v-dialog v-model="visible" max-width="500px" persistent>
    <v-card>
      <v-toolbar dense flat :color="esEdicion ? 'orange darken-2' : 'primary'" dark>
        <v-toolbar-title class="text-subtitle-1 font-weight-bold">
          <v-icon left small>{{ esEdicion ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          {{ esEdicion ? 'Editar' : 'Registrar' }} Tipo Lista Precio
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon small dark @click="cerrar" :disabled="enviando">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-4">
        <v-form ref="formulario" @submit.prevent="guardar">
          <v-text-field
            v-model="form.nombre"
            label="Nombre"
            outlined
            dense
            :rules="reglas.nombre"
            :error-messages="erroresServidor.nombre"
            @input="limpiarErrorServidor('nombre')" />
        </v-form>

        <!-- Errores generales del servidor -->
        <v-alert
          v-if="mensajeError"
          type="error"
          dense
          text
          class="mt-2 mb-0">
          {{ mensajeError }}
        </v-alert>
      </v-card-text>

      <v-divider />

      <v-card-actions class="px-4 py-3">
        <v-spacer />
        <v-btn text color="grey darken-1" @click="cerrar" :disabled="enviando">
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          :loading="enviando"
          @click="guardar">
          {{ esEdicion ? 'Actualizar' : 'Guardar' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TipoListaPrecioService from '../../services/tipo-lista-precio.service';

export default {
  name: 'FormularioTipoListaPrecio',
  props: {
    universidadId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      visible: false,
      enviando: false,
      mensajeError: '',
      form: {
        id: null,
        nombre: '',
      },
      erroresServidor: {},
      reglas: {
        nombre: [
          (v) => !!v || 'El nombre es requerido',
          (v) => (v && v.length >= 2) || 'El nombre debe tener al menos 2 caracteres',
        ],
      },
    };
  },
  computed: {
    esEdicion() {
      return !!this.form.id;
    },
  },
  methods: {
    abrir(item = null) {
      this.mensajeError = '';
      this.erroresServidor = {};

      if (item) {
        this.form = {
          id: item.id,
          nombre: item.nombre,
        };
      } else {
        this.form = {
          id: null,
          nombre: '',
        };
      }

      this.visible = true;

      this.$nextTick(() => {
        this.$refs.formulario?.resetValidation();
      });
    },
    cerrar() {
      this.visible = false;
      this.mensajeError = '';
      this.erroresServidor = {};
    },
    limpiarErrorServidor(campo) {
      if (this.erroresServidor[campo]) {
        this.$set(this.erroresServidor, campo, []);
      }
    },
    async guardar() {
      if (!this.$refs.formulario.validate()) return;

      this.enviando = true;
      this.mensajeError = '';
      this.erroresServidor = {};

      try {
        const datos = {
          nombre: this.form.nombre,
          universidadId: this.universidadId,
        };

        if (this.esEdicion) {
          await TipoListaPrecioService.update(this.form.id, datos);
        } else {
          await TipoListaPrecioService.create(datos);
        }

        this.$notify({
          group: 'notifications',
          title: 'Tipo Lista Precio',
          text: this.esEdicion ? 'Actualizado correctamente' : 'Registrado correctamente',
          type: 'success',
        });

        this.$emit('guardado');
        this.cerrar();
      } catch (error) {
        const data = error?.response?.data;
        const status = error?.response?.status;

        if (status === 422 && data?.errores) {
          this.erroresServidor = data.errores;
        }

        this.mensajeError = data?.mensaje || error.message || 'Error al guardar';
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>
